<template>
  <landing-page
    label="telemedicine.telemedicine"
    description="telemedicine.introDesc"
    :labelColor="labelAndDescColor"
    :descColor="labelAndDescColor"
    :eggImgObj="{ componentName: 'telemedicine', imgName: 'telemedicineIntro', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBlueRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useTelemedicineStore } from "@/stores/telemedicine";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const telemedicineStore = useTelemedicineStore();
const commonStore = useCommonStore();
const router = useRouter();
const i18n = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const props = defineProps({
  labelAndDescColor: {
    type: String,
    default: "#7BA7D8",
  }
});
</script>